<div class="onboarding-backdrop">
  <section class="onboarding-dialog" role="dialog" aria-modal="true">
    <div class="dialog-header">
      <h2>Welcome to {{ appName }}</h2>
      <p>Set up how strangers will see you.</p>
    </div>

    <!-- Avatar -->
    <div class="avatar-upload-block">
      <div class="avatar-preview-wrap">
        <div class="avatar-circle" (click)="openPicker()">
          <app-user-avatar
            [name]="displayName() || '?'"
            [avatarUrl]="avatarUrl()"
          />
        </div>
        @if (avatarUrl()) {
          <button
            class="remove-avatar-btn"
            type="button"
            (click)="removeAvatar()"
            aria-label="Remove avatar"
          >
            ×
          </button>
        }
      </div>
      <div class="avatar-actions">
        <button class="choose-avatar-btn" type="button" (click)="openPicker()">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="8" r="6" />
            <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
          </svg>
          Choose Avatar
        </button>
        <label class="upload-label" tabindex="0">
          <input
            type="file"
            accept="image/*"
            class="sr-only"
            (change)="handleAvatarChange($event)"
          />
          <span>Upload photo</span>
        </label>
      </div>
    </div>

    @if (pickerOpen()) {
      <app-avatar-picker
        [currentUrl]="avatarUrl()"
        (select)="onPickerSelect($event)"
        (cancel)="pickerOpen.set(false)"
      />
    }

    <!-- Name -->
    <div class="field-block">
      <div class="field-label">Your display name</div>
      <div class="name-row">
        <input
          [ngModel]="displayName()"
          (ngModelChange)="displayName.set($event)"
          maxlength="40"
          placeholder="Pick a name…"
        /><button class="random-button" type="button" (click)="randomName()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"
            ></path>
            <path d="m14 7 3 3"></path>
            <path d="M5 6v4"></path>
            <path d="M19 14v4"></path>
            <path d="M10 2v2"></path>
            <path d="M7 8H3"></path>
            <path d="M21 16h-4"></path>
            <path d="M11 3H9"></path></svg
          >Random
        </button>
      </div>
    </div>

    <!-- Gender -->
    <div class="field-block">
      <div class="field-label">Your gender</div>
      <div class="gender-grid">
        <button
          type="button"
          [class.selected]="gender() === 'male'"
          (click)="gender.set('male')"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle
              cx="10"
              cy="14"
              r="6"
              stroke="#4A90D9"
              stroke-width="2.2"
            ></circle>
            <line
              x1="14.8"
              y1="9.2"
              x2="20"
              y2="4"
              stroke="#4A90D9"
              stroke-width="2.2"
              stroke-linecap="round"
            ></line>
            <polyline
              points="16,4 20,4 20,8"
              stroke="#4A90D9"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></polyline></svg
          ><small>Male</small>
        </button>
        <button
          type="button"
          [class.selected]="gender() === 'female'"
          (click)="gender.set('female')"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle
              cx="12"
              cy="8"
              r="6"
              stroke="#E86BAD"
              stroke-width="2.2"
            ></circle>
            <line
              x1="12"
              y1="14"
              x2="12"
              y2="21"
              stroke="#E86BAD"
              stroke-width="2.2"
              stroke-linecap="round"
            ></line>
            <line
              x1="9"
              y1="18"
              x2="15"
              y2="18"
              stroke="#E86BAD"
              stroke-width="2.2"
              stroke-linecap="round"
            ></line></svg
          ><small>Female</small>
        </button>
        <button
          type="button"
          [class.selected]="gender() === 'non-binary'"
          (click)="gender.set('non-binary')"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle
              cx="9"
              cy="13"
              r="5.2"
              stroke="#D6457A"
              stroke-width="2.1"
            ></circle>
            <circle
              cx="15"
              cy="13"
              r="5.2"
              stroke="#624FA4"
              stroke-width="2.1"
            ></circle>
            <line
              x1="18.2"
              y1="6.2"
              x2="22"
              y2="2"
              stroke="#624FA4"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line>
            <polyline
              points="19,2 22,2 22,5"
              stroke="#624FA4"
              stroke-width="2.1"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></polyline></svg
          ><small>Non-binary</small>
        </button>
        <button
          type="button"
          [class.selected]="gender() === 'gay'"
          (click)="gender.set('gay')"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle
              cx="8"
              cy="14"
              r="5"
              stroke="#4A90D9"
              stroke-width="2.1"
            ></circle>
            <circle
              cx="16"
              cy="14"
              r="5"
              stroke="#5B6EE1"
              stroke-width="2.1"
            ></circle>
            <line
              x1="12.2"
              y1="9.8"
              x2="16"
              y2="4"
              stroke="#5B6EE1"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line>
            <polyline
              points="13,4 16,4 16,7"
              stroke="#5B6EE1"
              stroke-width="2.1"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></polyline>
            <line
              x1="8.2"
              y1="9.8"
              x2="11"
              y2="5"
              stroke="#4A90D9"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line>
            <polyline
              points="8,5 11,5 11,8"
              stroke="#4A90D9"
              stroke-width="2.1"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></polyline></svg
          ><small>Gay</small>
        </button>
        <button
          type="button"
          [class.selected]="gender() === 'lesbian'"
          (click)="gender.set('lesbian')"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle
              cx="8"
              cy="9"
              r="5"
              stroke="#E86BAD"
              stroke-width="2.1"
            ></circle>
            <circle
              cx="16"
              cy="9"
              r="5"
              stroke="#C23B8A"
              stroke-width="2.1"
            ></circle>
            <line
              x1="8"
              y1="14"
              x2="8"
              y2="21"
              stroke="#E86BAD"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line>
            <line
              x1="16"
              y1="14"
              x2="16"
              y2="21"
              stroke="#C23B8A"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line>
            <line
              x1="5"
              y1="18"
              x2="11"
              y2="18"
              stroke="#E86BAD"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line>
            <line
              x1="13"
              y1="18"
              x2="19"
              y2="18"
              stroke="#C23B8A"
              stroke-width="2.1"
              stroke-linecap="round"
            ></line></svg
          ><small>Lesbian</small>
        </button>
      </div>
    </div>

    <label class="age-gate">
      <input
        type="checkbox"
        [ngModel]="accepted()"
        (ngModelChange)="accepted.set($event)"
      />
      <span
        >I'm at least <strong>18 years old</strong> and agree to the
        <a routerLink="/terms" (click)="$event.stopPropagation()"
          >Terms of Service</a
        >
        and
        <a routerLink="/privacy" (click)="$event.stopPropagation()"
          >Privacy Policy</a
        >.
      </span>
    </label>

    <button
      class="continue-button"
      type="button"
      [disabled]="!canContinue()"
      (click)="submit()"
    >
      Continue
    </button>
  </section>
</div>
